<template>
  <div id="StepsResume">
    <div class="steps-list row m-0" id="stepsList">
      <div class="col-4" id="step1">
        <div class="row step d-flex align-items-center">
          <div style="height: 5px;" class="w-100 d-flex justify-content-center align-items-center col-6 m-0 bg-primary"></div>
          <div class="number border bg-primary border-primary text-white">
            <span>1</span>
          </div>
          <div style="height: 5px;" class="w-100 d-flex justify-content-center align-items-center col-6 m-0"
            v-bind:class="{ 'bg-dark': currentStep == 1, 'bg-primary': currentStep > 1 }"></div>
        </div>
        <div class="mt-4 text-center col-12 text-primary">
          <div>Selecciona el producto</div>
        </div>
      </div>
      <div class="col-4" id="step2">
        <div class="row step d-flex align-items-center">
          <div style="height: 5px;" class="w-100 d-flex justify-content-center align-items-center col-6 m-0"
            v-bind:class="{ 'bg-dark': currentStep < 2,'bg-primary': currentStep > 1 }"></div>
          <div class="number border"
            v-bind:class="{ 'bg-dark border-dark': currentStep < 2, 'bg-primary border-primary': currentStep >= 2 }">
            <span class="text-white">2</span>
          </div>
          <div style="height: 5px;" class="w-100 d-flex justify-content-center align-items-center col-6 m-0"
            v-bind:class="{ 'bg-dark': currentStep < 3,'bg-primary': currentStep > 2 }"></div>
        </div>
        <div class="mt-4 text-center col-12" v-bind:class="{ 'text-primary': currentStep > 1}">
          <div v-bind:class="{'text-dark': currentStep <= 1}">Detalles de cliente</div>
        </div>
      </div>
      <div class="col-4" id="step3">
        <div class="row step d-flex align-items-center">
          <div style="height: 5px;" class="w-100 d-flex justify-content-center align-items-center col-6 m-0"
            v-bind:class="{ 'bg-dark': currentStep < 3,'bg-primary': currentStep > 2 }"></div>
          <div class="number border"
            v-bind:class="{ 'bg-dark border-dark': currentStep < 3, 'bg-primary border-primary text-white': currentStep >= 3 }">
            <span class="text-white">3</span>
          </div>
          <div style="height: 5px;" class="w-100 d-flex justify-content-center align-items-center col-6 m-0"
            v-bind:class="{ 'bg-dark': currentStep <= 3,'bg-primary': currentStep > 3 }"></div>
        </div>
        <div class="mt-4 text-center col-12" v-bind:class="{ 'text-primary': currentStep > 2 }">
          <div v-bind:class="{'text-dark': currentStep <= 2}">Resumen renovación</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'StepsResume',
  props: [
    'currentStep',
  ],
};
</script>

<style lang="scss">
#StepsResume {
  .number {
    position: absolute;
    left: 46%;
    border-radius: 100%;
    z-index: 5;
    width: 30px;
    height: 30px;
    @media(max-width: 1180px) {
      left: 45%;
    }

    span {
      position: absolute;
      top: 10%;
      left: 35%;
    }
  }
}
</style>
